import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api/api';

export const meKeys = {
  all: ['me'] as const,
};

export const meOptions = () =>
  queryOptions({
    queryKey: meKeys.all,
    queryFn: () => api.getMe(),
  });
